import Markdown from 'react-markdown';
import dedent from 'dedent';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

const TAG_NAME_TO_VARIANT = {
  h1: TYPOGRAPHY_VARIANT.h1,
  h2: TYPOGRAPHY_VARIANT.h2,
  h3: TYPOGRAPHY_VARIANT.h3,
};
const DEFAULT_VARIANT = TYPOGRAPHY_VARIANT.h3;

const HeadingRenderer = ({ node, children }) => {
  return (
    <CustomTypography variant={TAG_NAME_TO_VARIANT[node.tagName] || DEFAULT_VARIANT}>
      {children}
    </CustomTypography>
  );
};

HeadingRenderer.propTypes = {
  node: PropTypes.shape({
    tagName: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export const CustomMarkdown = ({ text }) => {
  const str = dedent(text);
  return (
    <Markdown components={{ h1: HeadingRenderer, h2: HeadingRenderer, h3: HeadingRenderer }}>
      {str}
    </Markdown>
  );
};
CustomMarkdown.propTypes = {
  text: PropTypes.string.isRequired,
};
